import React, { useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Table from "react-bootstrap/Table";
import Layout from "../Components/Layout/Layout";
import Modal from "react-bootstrap/Modal";
import { useDispatch, useSelector } from "react-redux";
import { startstopLoading } from "../Redux/Reducers/globalSlice";
import { getAllSongs } from "../Redux/Actions/songs";
import NoData from "../Components/NoData";
import {
  capitalize,
  formatEventDetails,
  formatLocation,
  formatSimpleDate,
  getThreeMonthsBefore,
  getTwoMonthsBefore,
} from "../Utils/commonFiles";
import PaginationComponent from "../Components/Pagination";
import { getUpcomingEvent } from "../Redux/Actions/eventData";
import { useNavigate } from "react-router-dom";

export const genreOptions = {
  "Popular_chart": 'Popular/Chart',
  "Film_tv": 'Film/TV',
  'Jazz': "Jazz",
  'Classical': "Classical",
};

export default function Home() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const songLists = useSelector((e) => e.songAuth.songsList);
  const eventUpcoming = useSelector((e) => e.eventAuth.upcomingEvent);
  const { formattedDate, formattedTime } = eventUpcoming
    ? formatEventDetails(eventUpcoming?.eventDate, eventUpcoming?.eventTime)
    : { formattedDate: "", formattedTime: "" };

  const totalEntries = songLists?.total ?? 0;
  const entriesPerPage = 5;
  const totalPages = Math.ceil(totalEntries / entriesPerPage);

  const [currentPage, setCurrentPage] = useState(0);
  const [eventId, setEventId] = useState("");
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useEffect(() => {
    dispatch(startstopLoading(true));
    dispatch(getUpcomingEvent()).then((res) => {
      let id = res?.payload?.data?._id;
      if (!id) return dispatch(startstopLoading(false));
      setEventId(id);
      dispatch(getAllSongs({ page: 0, limit: 5, eventId: id })).then((res) => {
        dispatch(startstopLoading(false));
      });
    });
  }, [dispatch]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    dispatch(getAllSongs({ page: page, limit: 5, eventId }));
  };



  return (
    <Layout className="main-wrap">
      <Container fluid className="mt-4 p-0 custom-boxx">
        <Row>
          <Col lg={8}>
            <div className="home-profile">
              <div className="home-profile-data">
                {/* <div className="profile-view">
                  <img
                    src={eventUpcoming?.musician?.image ? eventUpcoming.musician.image : require("../Assets/Images/user-placeholder.png")}
                  />
                  <div>
                    <p>Musician</p>
                    <h2>{eventUpcoming?.musician?.fullName}</h2>
                  </div>
                </div> */}

                <div className="profile-view">
                  {eventUpcoming?.musician?.fullName
                    ?.toLowerCase()
                    .includes("bianca") &&
                    eventUpcoming?.musician?.fullName
                      ?.toLowerCase()
                      .includes("blezard") ? (
                    <img
                      src={require("../Assets/Images/biancaimg.jpg")}
                      alt="Bianca Blezard"
                      width="100"
                      height="100"
                    />
                  ) : eventUpcoming?.musician?.fullName
                    ?.toLowerCase()
                    .includes("estere") ? (
                    <img
                      src={require("../Assets/Images/estereimg.jpg")}
                      alt="Estere"
                      width="100"
                      height="100"
                    />
                  ) : (
                    <img
                      src={require("../Assets/Images/user-placeholder.png")}
                      alt="Default User"
                      width="100"
                      height="100"
                    />
                  )}
                  <div>
                    <p>Musician</p>
                    <h2>{eventUpcoming?.musician?.fullName}</h2>
                  </div>
                </div>

                <div className="hide-in-mobile">
                  {eventUpcoming && <p>Wedding Package</p>}
                  {eventUpcoming ? (
                    <h2>{capitalize(eventUpcoming?.eventName)}</h2>
                  ) : (
                    <p>No Wedding Package</p>
                  )}
                </div>
              </div>
              <div className="home-profile-schedule">
                <p>
                  Welcome to your wedding management portal! Here, you can
                  easily organise every detail of your booking from selecting
                  the perfect songs to handling payments securely. If you have
                  any questions, please contact me directly by clicking the
                  messaging icon in the top right of this screen.
                </p>
                <div className="hide-in-web">
                  {eventUpcoming && <p>Wedding Package</p>}
                  {eventUpcoming ? (
                    <h2>{capitalize(eventUpcoming?.eventName)}</h2>
                  ) : (
                    <p>No Wedding Package</p>
                  )}
                </div>

                <div>
                  {eventUpcoming && (
                    <span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          d="M15.8333 3.98145H4.16667C3.24619 3.98145 2.5 4.64473 2.5 5.46293V15.8333C2.5 16.6515 3.24619 17.3148 4.16667 17.3148H15.8333C16.7538 17.3148 17.5 16.6515 17.5 15.8333V5.46293C17.5 4.64473 16.7538 3.98145 15.8333 3.98145Z"
                          stroke="#979699"
                          stroke-width="1.48148"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M13.334 2.5V5.46296"
                          stroke="#979699"
                          stroke-width="1.48148"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M6.66602 2.5V5.46296"
                          stroke="#979699"
                          stroke-width="1.48148"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M2.5 8.42578H17.5"
                          stroke="#979699"
                          stroke-width="1.48148"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      {/* {formatSimpleDate(eventUpcoming?.eventDate)} */}
                      {formattedDate}
                    </span>
                  )}

                  {formattedTime && (
                    <span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <g clip-path="url(#clip0_165_7964)">
                          <path
                            d="M9.99675 19.1663C4.94209 19.1663 0.830078 15.0543 0.830078 9.99968C0.830078 4.94502 4.94209 0.833008 9.99675 0.833008C15.0514 0.833008 19.1634 4.94502 19.1634 9.99968C19.1634 15.0543 15.0514 19.1663 9.99675 19.1663ZM9.99675 2.36079C5.78466 2.36079 2.35786 5.78759 2.35786 9.99968C2.35786 14.2118 5.78466 17.6386 9.99675 17.6386C14.2088 17.6386 17.6356 14.2118 17.6356 9.99968C17.6356 5.78759 14.2088 2.36079 9.99675 2.36079ZM11.9065 13.3073C11.9934 13.2572 12.0696 13.1905 12.1308 13.1109C12.1919 13.0313 12.2367 12.9405 12.2627 12.8436C12.2886 12.7466 12.2952 12.6455 12.2821 12.5461C12.2689 12.4466 12.2363 12.3507 12.1861 12.2638L10.7606 9.79495V5.41634C10.7606 5.21375 10.6802 5.01945 10.5369 4.87619C10.3936 4.73293 10.1993 4.65245 9.99675 4.65245C9.79415 4.65245 9.59985 4.73293 9.4566 4.87619C9.31334 5.01945 9.23286 5.21375 9.23286 5.41634V9.99968C9.23286 10.1341 9.268 10.2655 9.33522 10.3816L10.863 13.0277C10.9643 13.2032 11.1311 13.3312 11.3268 13.3836C11.5225 13.4361 11.731 13.4086 11.9065 13.3073Z"
                            fill="#979699"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_165_7964">
                            <rect width="20" height="20" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                      {formattedTime}
                    </span>
                  )}

                  {eventUpcoming && (
                    <div className="d-flex align-items-center justify-content-end">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <g clip-path="url(#clip0_165_7971)">
                          <path
                            d="M9.9974 5C9.33813 5 8.69366 5.1955 8.1455 5.56177C7.59733 5.92804 7.17009 6.44863 6.9178 7.05772C6.66551 7.66681 6.5995 8.33703 6.72811 8.98363C6.85673 9.63024 7.1742 10.2242 7.64037 10.6904C8.10655 11.1565 8.70049 11.474 9.3471 11.6026C9.9937 11.7312 10.6639 11.6652 11.273 11.4129C11.8821 11.1606 12.4027 10.7334 12.769 10.1852C13.1352 9.63707 13.3307 8.9926 13.3307 8.33333C13.3307 7.44928 12.9795 6.60143 12.3544 5.97631C11.7293 5.35119 10.8815 5 9.9974 5ZM9.9974 10C9.66776 10 9.34553 9.90225 9.07145 9.71912C8.79737 9.53598 8.58374 9.27568 8.4576 8.97114C8.33145 8.6666 8.29845 8.33149 8.36276 8.00818C8.42706 7.68488 8.5858 7.38791 8.81889 7.15482C9.05197 6.92174 9.34895 6.763 9.67225 6.69869C9.99555 6.63438 10.3307 6.66739 10.6352 6.79353C10.9397 6.91968 11.2 7.1333 11.3832 7.40738C11.5663 7.68147 11.6641 8.0037 11.6641 8.33333C11.6641 8.77536 11.4885 9.19928 11.1759 9.51184C10.8633 9.82441 10.4394 10 9.9974 10Z"
                            fill="#979699"
                          />
                          <path
                            d="M9.99831 20.0002C9.29659 20.0038 8.60423 19.8392 7.9792 19.5202C7.35416 19.2013 6.81464 18.7372 6.40581 18.1669C3.22997 13.786 1.61914 10.4927 1.61914 8.3777C1.61914 6.15541 2.50194 4.02413 4.07334 2.45274C5.64474 0.881338 7.77601 -0.00146484 9.99831 -0.00146484C12.2206 -0.00146484 14.3519 0.881338 15.9233 2.45274C17.4947 4.02413 18.3775 6.15541 18.3775 8.3777C18.3775 10.4927 16.7666 13.786 13.5908 18.1669C13.182 18.7372 12.6425 19.2013 12.0174 19.5202C11.3924 19.8392 10.7 20.0038 9.99831 20.0002ZM9.99831 1.8177C8.25866 1.81969 6.59082 2.51164 5.3607 3.74176C4.13058 4.97188 3.43863 6.63972 3.43664 8.37937C3.43664 10.0544 5.01414 13.1519 7.87747 17.101C8.12055 17.4359 8.43945 17.7084 8.80807 17.8963C9.17669 18.0842 9.58456 18.1821 9.99831 18.1821C10.4121 18.1821 10.8199 18.0842 11.1885 17.8963C11.5572 17.7084 11.8761 17.4359 12.1191 17.101C14.9825 13.1519 16.56 10.0544 16.56 8.37937C16.558 6.63972 15.866 4.97188 14.6359 3.74176C13.4058 2.51164 11.738 1.81969 9.99831 1.8177Z"
                            fill="#979699"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_165_7971">
                            <rect width="20" height="20" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                      <span
                        style={{
                          wordBreak: 'break-word',
                          overflowWrap: 'break-word',
                          maxWidth: '200px',
                          display: 'inline-block'
                        }}
                        className="truncate text-wrap"
                      >
                        {capitalize(eventUpcoming?.location)}
                      </span>
                      {/* <span
                        style={{
                          wordBreak: 'break-word',
                          overflowWrap: 'break-word',
                          maxWidth: '200px',
                          display: 'inline-block'
                        }}
                        className="truncate text-wrap"
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        title={capitalize(eventUpcoming.location)}
                      >
                        {formatLocation(capitalize(eventUpcoming?.location))}
                      </span> */}
                    </div>
                  )}
                </div>
              </div>

              <div className="comn-table-title mt-2 mb-3">
                <h3>
                  Song list <span>({songLists?.total})</span>
                </h3>
              </div>
              <div className="filters">
                <div className="inner-filter-field">
                  <div class="table-responsive">
                    <Table size="sm" className="table-cmn">
                      <thead>
                        <tr>
                          <th>
                            <div className="user-checkbox">Song name</div>
                          </th>
                          <th>Artist</th>
                          <th>Genre </th>
                          {/* <th>Duration</th> */}
                          <th>Section</th>
                        </tr>
                      </thead>
                      <tbody>
                        {songLists?.songs?.length > 0 &&
                          songLists?.songs?.map((item, i) => (
                            <tr key={i}>
                              <td>
                                <div className="first-user gap-2">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="36"
                                    height="36"
                                    viewBox="0 0 36 36"
                                    fill="none"
                                  >
                                    <path
                                      d="M25 10.6667V25.3333C25 25.5986 24.8946 25.8529 24.7071 26.0404C24.5196 26.228 24.2652 26.3333 24 26.3333C23.7348 26.3333 23.4804 26.228 23.2929 26.0404C23.1054 25.8529 23 25.5986 23 25.3333V10.6667C23 10.4015 23.1054 10.1471 23.2929 9.95956C23.4804 9.77202 23.7348 9.66667 24 9.66667C24.2652 9.66667 24.5196 9.77202 24.7071 9.95956C24.8946 10.1471 25 10.4015 25 10.6667ZM20 6C19.7348 6 19.4804 6.10536 19.2929 6.29289C19.1054 6.48043 19 6.73478 19 7V29C19 29.2652 19.1054 29.5196 19.2929 29.7071C19.4804 29.8946 19.7348 30 20 30C20.2652 30 20.5196 29.8946 20.7071 29.7071C20.8946 29.5196 21 29.2652 21 29V7C21 6.73478 20.8946 6.48043 20.7071 6.29289C20.5196 6.10536 20.2652 6 20 6ZM28 13.3333C27.7348 13.3333 27.4804 13.4387 27.2929 13.6262C27.1054 13.8138 27 14.0681 27 14.3333V21C27 21.2652 27.1054 21.5196 27.2929 21.7071C27.4804 21.8946 27.7348 22 28 22C28.2652 22 28.5196 21.8946 28.7071 21.7071C28.8946 21.5196 29 21.2652 29 21V14.3333C29 14.0681 28.8946 13.8138 28.7071 13.6262C28.5196 13.4387 28.2652 13.3333 28 13.3333ZM16 10C15.7348 10 15.4804 10.1054 15.2929 10.2929C15.1054 10.4804 15 10.7348 15 11V25C15 25.2652 15.1054 25.5196 15.2929 25.7071C15.4804 25.8946 15.7348 26 16 26C16.2652 26 16.5196 25.8946 16.7071 25.7071C16.8946 25.5196 17 25.2652 17 25V11C17 10.7348 16.8946 10.4804 16.7071 10.2929C16.5196 10.1054 16.2652 10 16 10ZM12 13C11.7348 13 11.4804 13.1054 11.2929 13.2929C11.1054 13.4804 11 13.7348 11 14V22C11 22.2652 11.1054 22.5196 11.2929 22.7071C11.4804 22.8946 11.7348 23 12 23C12.2652 23 12.5196 22.8946 12.7071 22.7071C12.8946 22.5196 13 22.2652 13 22V14C13 13.7348 12.8946 13.4804 12.7071 13.2929C12.5196 13.1054 12.2652 13 12 13ZM8 15C7.73478 15 7.48043 15.1054 7.29289 15.2929C7.10536 15.4804 7 15.7348 7 16V20C7 20.2652 7.10536 20.5196 7.29289 20.7071C7.48043 20.8946 7.73478 21 8 21C8.26522 21 8.51957 20.8946 8.70711 20.7071C8.89464 20.5196 9 20.2652 9 20V16C9 15.7348 8.89464 15.4804 8.70711 15.2929C8.51957 15.1054 8.26522 15 8 15Z"
                                      fill="#979699"
                                    />
                                  </svg>
                                  <div className="user-profile">
                                    {" "}
                                    {capitalize(item?.title)}
                                  </div>
                                </div>
                              </td>
                              <td>{capitalize(item?.artist)}</td>
                              <td>{genreOptions[item?.genre] || 'N/A'}</td>
                              {/* <td>{item?.duration || 'N/A'}</td> */}
                              <td>{item.sectionName}</td>
                            </tr>
                          ))}
                      </tbody>
                    </Table>
                    {songLists?.total > 1 && (
                      <PaginationComponent
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={handlePageChange}
                        totalEntries={totalEntries}
                        entriesPerPage={entriesPerPage}
                      />
                    )}
                  </div>
                  {songLists?.songs?.length == 0 && (
                    <div className="no-custom-data">
                      {" "}
                      <NoData />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </Col>
          <Col lg={4} className="mt-2 mt-lg-0">
            <div className="to-do-list-home">
              <h2>To-Do List</h2>
              {eventUpcoming && (
                <ul>
                  <li>
                    <div>
                      <h3>
                        Submit song choices by{" "}
                        {getThreeMonthsBefore(eventUpcoming?.eventDate)}
                      </h3>
                    </div>
                    <p>
                      Please ensure your song choices are in before the deadline
                      so we can fulfil your requirements.
                    </p>
                  </li>
                  {/* <li>

                    {eventUpcoming && (
                      <div>
                        <h3>
                          Pending payment of £{eventUpcoming?.price}{" "}
                          <span
                            style={{ cursor: "pointer" }}
                            onClick={() => navigate("/payments")}
                          >
                            Pay Now
                          </span>
                        </h3>
                      </div>
                    )}
                    <p>
                      We require payments of outstanding balances to be paid 2
                      months before the event
                    </p>
                  </li> */}
                  <li>
                    {eventUpcoming?.transactions?.length > 0 && (
                      <>
                        <h3 className="mb-3">
                          {eventUpcoming?.transactions?.some((t) => t.amount === 100) ? (
                            <>
                              Pending Payment of £100 Deposit Due Now{" "}
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => navigate("/payments")}
                              >
                                Pay Now
                              </span>
                            </>
                          ) : (
                            <>
                              Pending Payment of £{eventUpcoming.price} {" "}
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => navigate("/payments")}
                              >
                                Pay Now
                              </span>
                            </>
                          )}
                        </h3>
                        <p>
                          {eventUpcoming?.transactions?.some((t) => t.amount === 100)
                            ? "We require deposits to be paid at the point of booking your event"
                            : "We require the outstanding balance to be paid no later than 7 days before the event"}
                        </p>
                      </>
                    )}
                  </li>
                </ul>
              )}
            </div>
          </Col>
        </Row>
      </Container>
      <div className="pb-4">
        <p className="mb-0"></p>
      </div>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header className="border-none justify-content-center">
          <Modal.Title className="mt-3">Request a change</Modal.Title>
        </Modal.Header>
        <Modal.Body className="py-0">
          <div>
            <Form>
              <div className="modal-cmn-form-set">
                <Form.Group className="mb-3" controlId="formBasicEmail">
                  <Form.Label>Message</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    placeholder="Lorem ipsum dolor sit"
                  />
                </Form.Group>
              </div>
            </Form>
          </div>
        </Modal.Body>
        <Modal.Footer className="border-none justify-content-center">
          <button className="secondary" onClick={handleClose}>
            Close
          </button>
          <button className="primary" onClick={handleClose}>
            Request
          </button>
        </Modal.Footer>
      </Modal>
    </Layout>
  );
}

